// Confirmation non bloquante, remplace `confirm()` natif sur les ecrans client.
//
// Meme principe que useToast : l'etat vit au niveau module, ConfirmHost (monte
// une fois dans App.vue) affiche la demande en cours dans une BaseModal, et
// l'appelant recoit une promesse qui vaut true si l'utilisateur confirme.
//
//   const { confirm } = useConfirm();
//   if (!(await confirm({ title: 'Annuler ?', message: '...', danger: true }))) return;
import { ref } from 'vue';

const pending = ref(null);

function settle(result) {
  const current = pending.value;
  pending.value = null;
  if (current?.resolve) current.resolve(result);
}

function confirm(options = {}) {
  const opts = typeof options === 'string' ? { message: options } : options;
  // Une seule demande a la fois : la precedente est refusee.
  if (pending.value) settle(false);
  return new Promise((resolve) => {
    pending.value = {
      title: opts.title || 'Confirmer',
      message: opts.message || '',
      confirmLabel: opts.confirmLabel || 'Confirmer',
      cancelLabel: opts.cancelLabel || 'Annuler',
      danger: !!opts.danger,
      resolve
    };
  });
}

export function useConfirm() {
  return {
    pending,
    confirm,
    accept: () => settle(true),
    cancel: () => settle(false)
  };
}
